import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import EmblaCarousel from 'embla-carousel';
// import AutoScroll from 'embla-carousel-auto-scroll';


// Alpine plugins

Alpine.plugin(focus);
Alpine.plugin(collapse);


// Header

window.initHeader = () => ({
    menuOpen: false,
    stuck: false,
    raf: null,
    preheaderHeight: 0,
    lastOffset: null,

    init() {
        this.preheader = document.querySelector('.preheader');
        this.flyout = document.querySelector('.header-flyout');
        this.measure();
        this.update();
    },

    measure() {
        this.preheaderHeight = this.preheader.offsetHeight;
    },

    handleScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.update();
        });
    },

    update() {
        const offset = Math.max(this.preheaderHeight - window.scrollY, 0);
        const stuck = window.scrollY > this.preheaderHeight;

        if (offset === this.lastOffset && stuck === this.stuck) return;

        this.lastOffset = offset;
        this.stuck = stuck;
        this.flyout.style.top = offset + 'px';
        this.flyout.style.height = `calc(100dvh - ${offset}px)`;
    }
});


// Sliders

window.initSlider = () => ({
    embla: null,
    canScrollPrev: false,
    canScrollNext: true,
    init() {
        const plugins = [];
        const options = {
            align: 'start',
        };

        // if (this.$refs.embla.dataset.autoscroll === 'true') {
        //     plugins.push(AutoScroll({
        //         stopOnInteraction: false,
        //         stopOnMouseEnter: true,
        //         speed: 1,
        //     }));
        //     options.loop = true;
        // }

        this.embla = EmblaCarousel(this.$refs.embla, options, plugins);

        const onSelect = () => {
            this.canScrollPrev = this.embla.canScrollPrev();
            this.canScrollNext = this.embla.canScrollNext();
        };

        this.embla.on('select', onSelect);
        onSelect();
    },
    scrollNext() {
        this.embla.scrollNext();
    },
    scrollPrev() {
        this.embla.scrollPrev();
    },
});


// Start Alpine

Alpine.start();


// Animations on scroll

const STAGGER_DELAY = 100; // ms between animations
const MAX_QUEUE = 6;       // beyond this, animate instantly (fast scroll)

let animationQueue = [];
let isProcessing = false;

const processQueue = () => {
    if (!animationQueue.length) {
        isProcessing = false;
        return;
    }
    animationQueue.shift().classList.add('animated');
    setTimeout(processQueue, STAGGER_DELAY);
};

const observerCallback = (entries) => {
    const entering = entries
        .filter(({ isIntersecting, target }) =>
            isIntersecting && !target.classList.contains('animated'))
        .sort((a, b) =>
            a.boundingClientRect.top - b.boundingClientRect.top ||
            a.boundingClientRect.left - b.boundingClientRect.left);

    if (!entering.length) return;

    if (animationQueue.length + entering.length > MAX_QUEUE) {
        // Scrolling too fast — flush everything immediately
        entering.forEach(({ target }) => target.classList.add('animated'));
        return;
    }

    animationQueue.push(...entering.map(({ target }) => target));
    if (!isProcessing) {
        isProcessing = true;
        processQueue();
    }
};

const animationObserver = new IntersectionObserver(observerCallback, {
    root: null,
    rootMargin: '0px',
    threshold: 0.01
});

document.querySelectorAll('.animates').forEach(item => {
    animationObserver.observe(item);
});